"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetFileUrl = void 0;
/**
 * Returns the URL needed to download an asset's file from a browser.
 */
function getAssetFileUrl(asset, filePath) {
    return `/api/project/${asset.projectId}/asset/${asset.id}/file/${filePath[0] === '/' ? filePath.slice(1) : filePath}`;
}
exports.getAssetFileUrl = getAssetFileUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0QXNzZXRGaWxlVXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2dldEFzc2V0RmlsZVVybC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQTs7R0FFRztBQUNILFNBQWdCLGVBQWUsQ0FDN0IsS0FBc0MsRUFDdEMsUUFBZ0I7SUFFaEIsT0FBTyxnQkFBZ0IsS0FBSyxDQUFDLFNBQVMsVUFBVSxLQUFLLENBQUMsRUFBRSxTQUN0RCxRQUFRLENBQUMsQ0FBQyxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUM1QyxFQUFFLENBQUM7QUFDTCxDQUFDO0FBUEQsMENBT0MifQ==